<template>
    <div class="addtask">
        <h2>新增考试任务</h2>
        <el-main class="addtaskcom">
            <h4>基本信息</h4>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="addtaskForm">
            <el-form-item label="任务名称:" prop="title">
                <el-input v-model="ruleForm.title" class="ruleInput"></el-input>
            </el-form-item>
                <el-form-item prop="timeDate" label="有效期:">
                    <el-date-picker
                    v-model="ruleForm.timeDate"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['00:00:00', '23:59:59']"
                    :picker-options="pickerOptions">
                    </el-date-picker>
                </el-form-item>
            <!-- </el-form-item> -->
            <el-form-item label="考试时长:" prop="num">
                <el-input-number v-model="ruleForm.num" controls-position="right"  :min="0" :max="300"></el-input-number>
                <span>分钟</span>
            </el-form-item>
            <h4>试卷模式</h4>
            <el-form-item label="试卷模式:" prop="resource">
                <el-radio-group v-model="ruleForm.resource" class="raido_task">
                    <el-radio label="1">固定试卷</el-radio>
                    <!-- <el-radio label="2">随机试卷</el-radio> -->
                </el-radio-group>
            </el-form-item>
            <el-form-item label="选择试卷:" prop="taskexam">
                <el-input v-model="ruleForm.taskexam" class="ruleInput" :disabled="true"></el-input>
                <el-button type="text" @click="addView(1)" ><i class="el-icon-plus"></i>选择试卷</el-button>
            </el-form-item>
            <el-form-item label="总分:" prop="p_scroe">
                {{p_scroe}}
                <span>分</span>
            </el-form-item>
            <el-form-item label="及格线:" prop="pogenum">
                {{ruleForm.pogenum}}
                <span>分</span>
            </el-form-item>
            <el-form-item label="指派范围:" class="scope_addtask"  style="min-height：82px;height:auto">
                <div class="scope_fw" style="width:720px;float:left">
                    <el-tag effect="plain" type="info"  v-for="(item,index) in Slist" :key="index" >{{item.title}}</el-tag>
                </div>
                <div class="scope_wrap" @click="addView(2)" style="width:94px;float:right">
                    <el-radio  class="rf radion_addtask"  v-model="ruleForm.scope" label="1" >部门/学员</el-radio>
                </div>
            </el-form-item>
            <h4>设置</h4>
            <el-form-item  class="option_addtask" label-width="0" >
                <div class="option_top">
                    <p >防作弊</p>
                </div>
                <div class="option_com">
                    <el-switch
                        v-model="ruleForm.cheat"
                        class="switch_addtask lf"
                        active-text="防作弊">
                    </el-switch>
                    <span class="ts_addtask lf">开启后试题顺序会随机打乱</span>
                </div>
            </el-form-item>
            <el-form-item  class="option_addtask" label-width="0">
                <div class="option_top">
                    <p>重考设置</p>
                </div>
                <div class="option_com">
                    <el-switch
                        v-model="ruleForm.reexamination"
                        class="switch_addtask lf"
                        @change="handchange"
                        active-text="允许重复考试">
                    </el-switch>
                    <span class="ts_addtask lf">开启后试题顺序会随机打乱</span>
                    <div class="clear"></div>
                        <!-- <el-radio-group v-model="ruleForm.reexamlen" class="raido_task reexamradio" v-if="reexam">
                            <el-radio label="1">学员及格后完成重考</el-radio>
                            <el-radio label="2">考试结束前无限制重考</el-radio>
                        </el-radio-group>
                        <el-radio-group v-model="ruleForm.reexamnum" class="raido_task reexamradio" v-if="reexam">
                            <el-radio label="1">记录学员最新成绩</el-radio>
                            <el-radio label="2">记录学员最高成绩</el-radio>
                        </el-radio-group> -->
                        <el-radio-group v-model="ruleForm.reexamradio" class="raido_task reexamradio">
                            <el-radio label="1">交卷后可查看答案和解析</el-radio>
                            <el-radio label="2">不允许查看答案和解析</el-radio>
                            <el-radio label="3">考试结束后可查看答案和解析</el-radio>
                        </el-radio-group>
                </div>
            </el-form-item>
            <el-form-item  class="option_addtask" label-width="0">
                <div class="option_top">
                    <p>阅卷方式</p>
                </div>
                <div class="option_com">
                    <el-radio-group v-model="ruleForm.reexammark" class="raido_task reexamradio">
                        <el-radio label="1" class="lf">系统阅卷<span class="reexam_addtask">开启后试题顺序会随机打乱</span></el-radio>
                        <el-radio label="2" class="lf">人工阅卷<span class="reexam_addtask">开启后试题顺序会随机打乱</span></el-radio>
                    </el-radio-group>
                </div>
            </el-form-item>
            <el-form-item  class="option_addtask" label-width="0">
                <div class="option_top">
                    <p>考试及格奖励</p>
                </div>
                <div class="option_com">
                    <el-checkbox-group v-model="ruleForm.checkList" @change="checkchange">
                        <div class="check_addtask"><el-checkbox label="2">及格奖励学分(分)</el-checkbox><el-input v-model="ruleForm.pass" class="check_input" :disabled="passin"></el-input><span class="ts_addtask">考试及格后，学员会获得相应的学分给予奖励</span></div>
                        <div class="check_addtask"><el-checkbox label="3">不及格奖励(分)</el-checkbox><el-input v-model="ruleForm.fail" class="check_input" :disabled="failin"></el-input><span class="ts_addtask">开启后试题顺序会随机打乱</span></div>
                        <div class="check_addtask"><el-checkbox label="4">缺考扣除(分)</el-checkbox><el-input v-model="ruleForm.Omission" class="check_input" :disabled="Omissin"></el-input><span class="ts_addtask">开启后试题顺序会随机打乱</span></div>
                    </el-checkbox-group>
                </div>
            </el-form-item>
             <!-- <el-form-item  class="option_addtask" label-width="0">
                <div class="option_top">
                    <p>监督人(1)</p><span>创建人为默认监督人</span>
                </div>
                <div class="option_com">
                    <span class="monitorPeo lf" v-for="(item,ix) in adminList">{{item.name}}</span>
                    <el-button type="button" class="lf monitorPeo_btn" @click="addView(3)"><i class="el-icon-plus"></i>添加监督人</el-button>
                    <div class="clear"></div>
                    <el-checkbox v-model="monitor">监督人协同阅卷</el-checkbox>
                </div>
            </el-form-item> -->
                <div class="addstaskUp">
                    <el-button type="primary" @click="submitForm('ruleForm')" :disabled='disablednum==1?true:false'>保存</el-button>
                    <el-button @click="hrefTo">返回</el-button>
                </div>
        </el-form>
        </el-main>
        <dialogFw :addViewExam.sync='addViewExam' :supshow.sync='supshow' :visible.sync='visible' @examViews='examViewsTxt' :bmid.sync="bmid"  @bmidfw='bmidfwtxt'></dialogFw>
    </div>
</template>

<script>
import dialogFw from '../Common/dialog'

export default{
    name:'addtask',
   data(){
        var validDate = (rule,value,callback) => {    
            if(value){  
                if(!value[0] || !value[1]){
                callback(new Error("请选择有效时间"))
                }else{  
                callback()
                }
            }
            else{
                callback(new Error("请选择有效时间"))
            }
        };
       return{
           pickerOptions:{
               disabledDate(v){
                   return v.getTime() < new Date().getTime() - 86400000
               }
           },
            reexam:0,
            certin:true,
            passin:true,
            type:0,
            supshow:false,
            addViewExam:false,
            failin:true,
            visible:false,
            p_scroe:'',
            monitor:'',
            disablednum:0,
            Omissin:true,
            Slist:[],
            adminList:[],
            bmid:0,
            ruleForm: {
                title: '',
                timeDate:'',
                num:'',
                resource:'1',
                pogenum:'',
                taskexam:'',
                scope:'0',
                taskexId:'',
                cheat:'',
                reexamradio:'1',
                reexamination:false,
                reexamlen:'1',
                checkList:[],
                reexammark:'1',
                examinee:[],
                reexamnum:'1',
                certificate:'',
                Omission:'',
                pass:'',
                fail:'',
                admin:[],
            },
            rules:{
                title: [
                    { required: true, message: '请输入任务名称', trigger: 'blur' },
                ],
            timeDate:[
                    {validator: validDate, trigger: 'change',required: true,message: '请选择开始和结束时间'}
                ],
            num:[
                {required: true, message: '请选择试卷模式', trigger: 'change blur'}
            ], 
            pogenum:[
                {required: true, message: '请选择试卷模式', trigger: 'change blur'}
            ],
            resource: [
                    { required: true, message: '请选择试卷模式', trigger: 'change' }
                ],
            taskexam: [
                    { required: true, message: '请选择试卷', trigger: 'change' }
                ],
            }
       }
   },
   components:{
    dialogFw
  },
   methods:{
       examViewsTxt(value,id,score,pass){
        this.ruleForm.taskexam=value
        this.ruleForm.taskexId=id
        this.p_scroe=score
        this.ruleForm.pogenum=pass
       },
       bmidfwtxt(id,data){
            if(id==1){
                let ids = []
                for(let i in data) {
                    ids.push(data[i].id)
                }
                ids = ids.join(',')
                this.ruleForm.examinee = ids

                let up = []
                // this.ruleForm.examinee=data
                this.Slist=data
                $.each(data,function(i,ix){
                    console.log(ix)
                    up.push(parseInt(ix.type))
                })
                console.log(up)
                if(up.indexOf(1)!=-1 && up.indexOf(2)!=-1){
                    this.type= 3
                }
                else if(up.indexOf(1)!=-1){
                    this.type= 1
                }else if(up.indexOf(2)!=-1){
                    this.type= 2
                }
            }
            else{
                this.ruleForm.admin=data
                this.adminList=data
            }
           if(data.length==0){
               this.ruleForm.scope='0'
           }
           else{
               this.ruleForm.scope='1'
           }
       },
       handchange(e){
           if(e==true){
               this.reexam=1
           }
           else{
               this.reexam=0
           }
           console.log(this.reexam)
       },
       addView(type){
           if(type==1){
            this.addViewExam=true
          }
          else if(type==2){
            this.visible=true
            this.bmid=1
            this.ruleForm.scope='0'
          }
          else{
              this.supshow=true
              this.bmid=2
          }
      },
       checkchange(e){
           if(e.indexOf('1')==-1){
               this.certin=true
           }
           else{
               this.certin=false
           }
            if(e.indexOf('2')==-1){
               this.passin=true
           }
           else{
               this.passin=false
           }
            if(e.indexOf('3')==-1){
               this.failin=true
           }
           else{
               this.failin=false
           }
            if(e.indexOf('4')==-1){
               this.Omissin=true
           }
           else{
               this.Omissin=false
           }
       },
       submitForm(formName) {   
            this.disablednum=1
            
            this.$refs[formName].validate((valid) => {
               if(valid){
                const startTime = this.ruleForm.timeDate[0]
                const endTIme = this.ruleForm.timeDate[1]
                // var d = this.ruleForm.timeDate[0]
                // var year = d.getFullYear();
                // var month = d.getMonth() + 1;
                // var date = d.getDate();
                // var datetime = year + '-' + (month > 9?(month + "") : ("0" + month))+ '-' + (date>9?(date + "") : ("0" + date));
                // var end = this.ruleForm.timeDate[1]
                // var endyear = end.getFullYear();
                // var endmonth = end.getMonth() + 1;
                // var enddate = end.getDate();
                // var edatetime = endyear + '-' + (endmonth > 9?(endmonth + "") : ("0" + endmonth))+ '-' + (enddate>9?(enddate + "") : ("0" + enddate));
                var data ={
                    service:'Examtask.AddExam',
                    title:this.ruleForm.title,
                    content:this.ruleForm.taskexId,
                    score:this.ruleForm.pogenum,
                    scores:this.p_scroe,
                    s_time: startTime,
                    e_time: endTIme,
                    time:this.ruleForm.num,
                    examinee:this.ruleForm.examinee,
                    type:this.type,
                    admin:JSON.stringify(this.ruleForm.admin),
                    retake:this.reexam,
                    marking:this.ruleForm.reexammark,
                    parsing:this.ruleForm.reexamradio,
                    userid:localStorage.getItem('userid')
                }
                if(this.ruleForm.examinee.length==0){
                    this.alertView.failView('请选择部门/人员')
            this.disablednum=0
                    return false
                }
                this.$axios.post(this.HOME,this.$qs.stringify(data))
                    .then(res=>{
                        console.log('res', res)
                        if(res.data.data.code == 0){
                           this.alertView.successView('新增成功')
                           this.$router.push({ path:'/task/'}) 
                        }
                        else{
                            this.disablednum=0
                            this.alertView.failView(res.data.data.msg)
                        }
                })
            }
            else{
                this.alertView.failView('还有信息未填写')
                this.disablednum=0
            }
        });
        },
        hrefTo(){
            this.$router.push({ path:'/task'})
        }
    
   },
}
</script>
<style>
    @import "../../assets/css/task.css";
    .scope_fw .el-tag--plain{padding:4px 12px;
    margin: 10px 0 10px;
    border: 1px solid #666;
    height: auto;
    margin-right: 20px;
    color: #666;
    font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/task/addtask.vue